import { Expose } from "class-transformer";

export class SelfPortalPageDto {
  @Expose()
  id!: string;

  @Expose()
  url!: string;
}
